import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-3">Information We Collect</h2>
          <p className="text-gray-700">
            When you sign in, we collect your basic Google profile information (name, email address, and profile picture) for authentication purposes.<br/>
            When you use our email generation feature, we request access to your Gmail account with the following permissions:
            <ul className="list-disc ml-6 mt-2 text-gray-700">
              <li>Read your Gmail messages and drafts</li>
              <li>Compose and send emails on your behalf</li>
              <li>Manage your email drafts</li>
            </ul>
            We only access your Gmail data as needed to generate and send emails at your request. We do not store your emails or Gmail data on our servers.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">How We Use Your Information</h2>
          <p className="text-gray-700">
            Your information is used to authenticate you, provide access to our services, and enable email generation features. We do not share your personal information with third parties except as required to provide our services or comply with the law.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Data Security</h2>
          <p className="text-gray-700">
            We take reasonable measures to protect your information from unauthorized access. You can revoke our access to your Google account at any time via your Google account settings.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Google API Services User Data Policy</h2>
          <p className="text-gray-700">
            We comply with the Google API Services User Data Policy, including the Limited Use requirements, for all data obtained through Google OAuth and Gmail APIs.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
          <p className="text-gray-700">
            If you have any questions about this Privacy Policy, please contact us at: support@quislab.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage; 